import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["id", "className"];
import { color, shadow } from '@repay/cactus-theme';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { omitMargins } from '../helpers/omit';
var RadioButtonBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var componentProps = omitMargins(props);

  var id = componentProps.id,
      className = componentProps.className,
      radioButtonProps = _objectWithoutProperties(componentProps, _excluded);

  return /*#__PURE__*/React.createElement("label", {
    className: className,
    htmlFor: id
  }, /*#__PURE__*/React.createElement(HiddenRadioButton, Object.assign({
    ref: ref,
    id: id
  }, radioButtonProps)), /*#__PURE__*/React.createElement(StyledRadioButton, {
    "aria-hidden": true
  }));
});
var HiddenRadioButton = /*#__PURE__*/styled.input.attrs({
  type: 'radio'
}).withConfig({
  displayName: "HiddenRadioButton"
})(["opacity:0;height:0;width:0;margin:0;position:absolute;"]);
var StyledRadioButton = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledRadioButton"
})(["display:inline-block;box-sizing:border-box;width:16px;height:16px;border-radius:50%;background-color:transparent;border:2px solid ", ";::after{position:absolute;content:'';display:none;width:8px;height:8px;border-radius:50%;background-color:", ";margin:2px;box-sizing:border-box;}"], color('base'), color('callToAction'));
export var RadioButton = /*#__PURE__*/styled(RadioButtonBase).withConfig({
  displayName: "RadioButton"
})(["position:relative;display:inline-block;vertical-align:-1px;line-height:16px;width:16px;height:16px;cursor:", ";input:checked ~ span{border-color:", ";&::after{display:block;}}input:focus ~ span{", "}input:disabled ~ span{background-color:", ";border-color:", ";&::after{background-color:", ";}}", ""], function (p) {
  return p.disabled ? 'cursor' : 'pointer';
}, color('callToAction'), shadow(1), color('lightGray'), color('lightGray'), color('lightGray'), margin);
RadioButton.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool
};
export default RadioButton;